module.exports = __webpack_public_path__ + "img/paramount.d2a08578.svg";